import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { RecipientPreview, SegmentDefinition } from "../../marketing.types";
import { requestPreviewRecipients } from "./previewRecipients.request";

const usePreviewRecipients = (
  options?: MutationOptions<
    RecipientPreview[],
    ApiServiceError<ApiError>,
    SegmentDefinition
  >
) => {
  return useMutation({
    mutationFn: requestPreviewRecipients,
    ...options
  });
};

export default usePreviewRecipients;
